import account from "../../data/account";

/*
 * Video quality (DS 2026-10-12, "make video cheaper"): every clip is made at Standard (Veo 3.1 Fast, 720p) or Best
 * (Veo 3.1, 1080p), sent to content_cinematic_agent as `quality` (the agent API reserves credits by it). The last choice
 * is remembered for the workspace in this browser (Studio keeps the same choice server-side). No credit amounts here.
 */
export const VIDEO_QUALITIES = [["standard", "Standard", "Quick, great for social and product pages"], ["best", "Best", "Full detail for hero videos"]];
export const DEFAULT_VIDEO_QUALITY = "best"; // R&S test 10-12: Fast changed the product on 2 of 3 clips
const key = () => `plunk-video-quality:${(account.get() || {}).tenantId || ""}`;
export function lastVideoQuality() {
  try {
    const v = localStorage.getItem(key());
    return v === "best" || v === "standard" ? v : DEFAULT_VIDEO_QUALITY;
  } catch (e) {
    return DEFAULT_VIDEO_QUALITY;
  }
}
export function rememberVideoQuality(v) {
  if (v !== "best" && v !== "standard") return;
  try {
    localStorage.setItem(key(), v);
  } catch (e) {/* private mode */}
}
export const qualityNote = v => (VIDEO_QUALITIES.find(([k]) => k === v) || VIDEO_QUALITIES[0])[2];